/* eslint no-template-curly-in-string: 0 */
import { PAYMENT_STATUSES, PAYMENT_NETWORKS, FLOW_TYPES } from "../../utils/enums";
import amazonLogo from '../../assets/images/logo-amazon.png';
import amazonCompleteImg from '../../assets/images/amazon.png';

const css = {
  ":root": {
    "--btn-primary-bg-color": "#f8991d",
    "--btn-primary-bg-color-hover": "#f8991d",
    "--btn-primary-font-color": "#fff",
    "--btn-primary-font-color-hover": "#fff"
  },
};

const aboutNetworkFaq = {
  answer: 'Amazon.com is not a sponsor of this promotion. Except as required by law, Amazon.com Gift Cards ("GCs") cannot be transferred for value or redeemed for cash. GCs may be used only for purchases of eligible goods on Amazon.com or certain of its affiliated websites. GCs cannot be redeemed for purchases of gift cards. Purchases are deducted from the GC balance. To redeem or view a GC balance, visit "Your Account" on Amazon.com. Amazon is not responsible if a GC is lost, stolen, destroyed or used without permission. For complete terms and conditions, see <a class="link" target="_blank" href="https://www.amazon.com/gc-legal">www.amazon.com/gc-legal</a>. GCs are issued by ACI Gift Cards, Inc., a Washington corporation. All Amazon ™ & © are IP of Amazon.com, Inc. or its affiliates. No expiration date or service fees.',
  question: "About Amazon.com Gift Card"
};

export const amazon = {
  id: PAYMENT_NETWORKS.EGIFT_TREMENDOUS_AMAZON,
  displayName: "Amazon.com Gift Card",
  paymentFlow: "email",
  paywall: {
    tile: {
      displayName: "Amazon.com Gift Card",
      tagline: "Use online right now",
      description: [
        {
          string: "Immediate funds to buy personal items,",
          type: "div",
        },
        {
          string: "gifts, food and more",
          type: "div",
        },
      ],
      // btnLabel: "Next",
      logo: amazonLogo
    }
  },
  recipientLogin: {
    flow: FLOW_TYPES.RECIPIENT_LOGIN.AUTO_LOGIN,
    loading: {
      title: "Preparing your Amazon.com gift card"
    }
  },
  acceptPayment: {
    css,
    flow: FLOW_TYPES.ACCEPT_PAYMENT.AUTO_ACCEPT,
    btnLabel: "GET MY AMAZON GIFT CARD",
    description: [
      "You have chosen to receive a ",
      {
        string: "${payment.amount}",
        transformations: [
          {
            type: "formatAsCurrency",
            data: {
              currency: "${payment.currency}"
            }
          }
        ],
        props: {
          className: "payment-amount",
        }
      },
      " Amazon.com Gift Card which will be emailed to ",
      {
        string: "${payment.recipientEmail}.",
        props: {
          className: 'payment-recipientEmail',
        }
      }
    ],
    imgSrc: amazonCompleteImg
  },
  networkSelectionAccepted: {
    imgSrc: amazonCompleteImg,
  },
  paymentComplete: {
    initial: {
      description: [
        "Success! Please check your email ",
        {
          string: "${payment.recipientEmail}",
          props: {
            className: 'payment-recipientEmail',
          },
        },
        " for details regarding your ",
        {
          string: "Amazon.com Gift Card",
          props: {
            className: 'payment-paymentNetwork',
          }
        },
        " for ",
        {
          string: "${payment.acceptedAmount}",
          transformations: [
            {
              type: "formatAsCurrency",
              data: {
                currency: "${payment.acceptedCurrency}"
              }
            }
          ],
          props: {
            className: "payment-amount",
          }
        },
        ".",
      ],
      secondaryText: "Please treat this card like cash and care for it accordingly to avoid loss or theft.",
    },
    revisit: {
      description: [
        "An email was sent to ",
        {
          string: "${payment.recipientEmail}",
          props: {
            className: 'payment-recipientEmail'
          },
        },
        " on ",
        {
          string: "${payment.updatedAt}",
          props: {
            className: 'payment-updatedAt'
          },
          transformations: [
            {
              type: "formatDate"
            }
          ],
        },
        " with details regarding your ",
        {
          string: "Amazon.com Gift Card",
          props: {
            className: 'payment-paymentNetwork'
          }
        },
        " for ",
        {
          string: "${payment.acceptedAmount}",
          transformations: [
            {
              type: "formatAsCurrency",
              data: {
                currency: "${payment.acceptedCurrency}"
              }
            }
          ],
          props: {
            className: "payment-amount",
          }
        },
        ".",
      ],
      secondaryText: "Please treat this card like cash and care for it accordingly to avoid loss or theft.",
    },
    imgSrc: amazonCompleteImg,
  },
  faqs: {
    byPaymentStatus: {
      [PAYMENT_STATUSES.PENDING_ACCEPTANCE]: [
        aboutNetworkFaq
      ],
      [PAYMENT_STATUSES.ACCEPTED]: [
        aboutNetworkFaq
      ],
      [PAYMENT_STATUSES.COMPLETE]: [
        aboutNetworkFaq
      ]
    }
  },
  onHold: {
    imgSrc: amazonCompleteImg,
    description: 'Your payment selection has been received. In most cases, funds are instantly sent; however in some instances it can take 24 to 48 hours for money to arrive.',
  }
};

export default amazon;
